import React from "react";
import SubscribeFrom from "./SubscribeForm";

const formProps = {
    action:
      "https://demeny.us17.list-manage.com/subscribe/post?u=284978380e06e8060dde18aa3&amp;id=8901278feb",
    messages: {
        inputPlaceholder: "Email Address",
        btnLabel: "Subscribe",
        sending: "Subscribing...",
        success: "Thank you!",
        error: "Oups, something went wrong. Please email <a style=\"color:red; font-weight:bold\" href=\"mailto:ana@demeny.com\">ana@demeny.com</a> and I will add you to the list."
      },
    styles: {
      sending: {
        fontSize: 16,
        color: "#777"
      },
      success: {
        fontSize: 16,
        color: "#49b100"
      },
      error: {
        fontSize: 16,
        color: "red"
      },
      style:{
        border: "1 solid red",
      }
    }
  };
  

export default class Subscribe extends React.Component {
  render () {
    return (
        <div>
            <SubscribeFrom {...formProps} />
        </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/templates/Subscribe.js